import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import UserInputFlowSingleTemplate from './UserInputFlowSingleTemplate'
import { lang } from '../../assets/lang'

export default class UserInputFlowSingleComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.USER_INPUT_FLOW_SINGLE)

    this.data.component = UserInputFlowSingleTemplate
    this.socket = config.sockets ? config.sockets : null
  }

  builder(node) {
    node.lingualName = lingualName.USER_INPUT_FLOW_SINGLE
    this.setConnection()

    const userInputFlowSingleInput = new Rete.Input(
      CONST_SOCKET.USER_INPUT_FLOW_SINGLE_INPUT, 
      lang.user_input_flow_single_socket_input_reply, 
      this.socket.userInputFlowSingleInput, 
      false
    )

    const userInputFlowSingleOutput = new Rete.Output(
      CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT, 
      lang.user_input_flow_single_socket_output_next, 
      this.socket.userInputFlowSingleOutput, 
      false
    )

    const userInputFlowSingleOutputFinalReply = new Rete.Output(
      CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY, 
      lang.user_input_flow_single_socket_output_final_reply, 
      this.socket.userInputFlowSingleOutputFinalReply, 
      false
    )

    return node
      .addInput(userInputFlowSingleInput)
      .addOutput(userInputFlowSingleOutput)
      .addOutput(userInputFlowSingleOutputFinalReply)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {}

  setConnection() {
    this.socket.userInputFlowSingleInput.combineWith(this.socket.userInputFlowOutput)

    this.socket.userInputFlowSingleOutput.combineWith(this.socket.userInputFlowSingleInput)
    
    this.socket.userInputFlowSingleOutputFinalReply.combineWith(this.socket.newPostbackInput)
  }
}